/**
 * Created by Yangxunwu on 2018/6/7.
 */

import request from '@/utils/request'

/**
 * 账号密码登录
 * @param phone
 * @param password
 */
export function loginByPhone(phone, password) {
    const data = {
        phone,
        password
    }
    return request({
        url: '/user/user/login',
        method: 'post',
        data
    })
}

/**
 * 短信验证码登录
 * @param phone
 * @param smsCode
 */
export function loginBySms(phone, smsCode) {

	const data = {
		phone,
		smsCode,
	}

	return request({
		url: "/user/user/login-by-sms",
		method: 'post',
		data
	})
}

/**
 * 登出
 */
export function logout() {
	return request({
		url: "/user/user/logout",
		method: 'post',
	})
}

/**
 * 获取账户星星包括绑定的企业信息
 */
export function getUserInfo() {
	return request({
		url: '/user/user/info',
		method: 'get',
	})
}

/**
 * 重置密码
 * @param oldPassword
 * @param password
 */
export function resetPassword(oldPassword, password) {

	const data = {
		oldPassword,
		password,
	};

	return request({
		url: '/user/user/reset-password',
		method: 'post',
		data
	})
}


// WEBPACK FOOTER //
// ./src/api/login.js